"use client";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../shadcn/navigation-menu";
import CartButton from "../buttons/CartButton";
import { Button } from "../../shadcn/button";
import Link from "next/link";
import useCart from "@/app/lib/features/cart/cart.hook";
import { useEffect, useState } from "react";
import CartNavigationSkeleton from "../skeletons/CartNavigationSkeleton";
import { getCartItemName, getCartItemImage } from "@/app/utils/cart.utils";
import CartProductCard from "../cards/cartProductCard/CartProductCard";

const PREVIEW_LIMIT = 3;

const CartNavigation = () => {
  const { cart, cartCount, isLoading, fetchCart } = useCart();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Sepet detayı yalnızca dropdown açıldığında çekilir.
  // Eskiden `cartCount > 0 && !cart` koşuluyla effect'ten çekiliyordu; bu,
  // sepete ekleme sırasında cart.hook'un attığı GET /cart ile AYNI ANDA ikinci
  // bir GET /cart doğuruyordu (POST + 2× GET). Ayrıca kullanıcı menüyü hiç
  // açmasa bile her sayfa yüklemesinde tam sepet çekiliyordu.
  const handleMenuOpenChange = (value: string) => {
    if (value && !cart && !isLoading) fetchCart();
  };

  const allItems = cart?.grouped_items?.flatMap((group) => group.items) || [];
  const previewItems = allItems.slice(0, PREVIEW_LIMIT);
  const remainingCount = allItems.length - PREVIEW_LIMIT;
  const hasMore = remainingCount > 0;

  return (
    <>
      {/* Mobile: Direct Link */}
      <div className="block md:hidden">
        <CartButton />
      </div>

      {/* Desktop: Hover Menu */}
      <div className="hidden md:block" suppressHydrationWarning>
        {mounted && <NavigationMenu viewport={false} delayDuration={0} onValueChange={handleMenuOpenChange}>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuTrigger className="p-0">
                <CartButton />
              </NavigationMenuTrigger>
              <NavigationMenuContent className="w-[320px]! right-0! left-auto! p-0!">
                <div className="h-12.5 flex items-center border-b p-4">
                  <h2 className="font-medium">Sepetim ({cartCount})</h2>
                </div>
                <div className="space-y-2 p-4">
                  {isLoading ? (
                    <CartNavigationSkeleton />
                  ) : previewItems.length > 0 ? (
                    <>
                      {previewItems.map((item) => (
                        <CartProductCard
                          key={item.id}
                          id={item.id}
                          image={getCartItemImage(item)}
                          name={getCartItemName(item)}
                          quantity={item.quantity}
                          price={item.total_price ?? item.price}
                          variant={item.variant}
                          slug={item.slug}
                          imageSize="md"
                          showPrice={true}
                        />
                      ))}

                      {hasMore && (
                        <div className="pt-2 pb-1 text-center">
                          <Link href="/sepet">
                            <Button variant="ghost" size="sm" className="w-full text-blue-600 hover:text-blue-700 hover:bg-blue-50">
                              +{remainingCount} ürün daha - Tümünü Gör
                            </Button>
                          </Link>
                        </div>
                      )}

                      <div className="grid grid-cols-2 gap-2 pt-2">
                        <Button className="w-full" variant="outline" asChild>
                          <Link href="/sepet">Sepete Git</Link>
                        </Button>
                        <Button className="w-full" asChild>
                          <Link href="/account/checkout">Siparişi Tamamla</Link>
                        </Button>
                      </div>
                    </>
                  ) : cartCount > 0 ? (
                    <div className="py-8 text-center">
                      <CartNavigationSkeleton />
                    </div>
                  ) : (
                    <div className="py-8 text-center">
                      <p className="text-sm text-gray-500">Sepetiniz boş</p>
                      <Button className="mt-4" variant="outline" asChild>
                        <Link href="/">Alışverişe Başla</Link>
                      </Button>
                    </div>
                  )}
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>}
      </div>
    </>
  );
};

export default CartNavigation;